module.exports = __webpack_public_path__ + "media/2.5b6c27e5.mp3";